// import { IInitiative } from '../services/IInitiative';
// import { IPriority } from '../services/IPriority';

import {StrtInitiative} from '../../shared/models/plan/StrtInitiative';
import {StrtPriority} from '../../shared/models/plan/StrtPriority';

export class InitiativeAndPriority {
    readonly initiative: StrtInitiative;
    readonly priority: StrtPriority;
    readonly INITIATIVE_DESCRIPTION_MAX_LENGTH = 95;
    selected = false;
    colorCode: string;
    title: string;
    text: string;
    id: number;

    constructor(initiative: StrtInitiative, priority: StrtPriority) {
      this.initiative = initiative;
      this.priority = priority;

      this.colorCode = this.priority.colorCode;
      this.title = this.priority.title;
      this.text = this.initiative.description;
      this.id = this.initiative.initiativeId;
    }
}
